module.exports = __webpack_public_path__ + "static/media/fr.09a791be.png";